import { Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import LoginDoctorPage from "./components/LoginDoctorPage";
import LoginPacientePage from "./components/LoginPacientPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login-doctor" element={<LoginDoctorPage />} />
      <Route path="/login-paciente" element={<LoginPacientePage />} />
    </Routes>
  );
}

export default App;